import { OriginStatus, OriginType } from '../Origin'
import { ValueObject } from './valueObject'

export type LeadDetailsProps = {
  leadId: string
  name: string
  email: string
  phone: string
  createdAt: Date
  updatedAt?: Date | null
  origin: {
    originId?: string
    name?: string
    type: OriginType
    status: OriginStatus
  }
}

export class LeadDetails extends ValueObject<LeadDetailsProps> {
  get leadId() {
    return this.props.leadId
  }
  get name() {
    return this.props.name
  }
  get email() {
    return this.props.email
  }
  get phone() {
    return this.props.phone
  }
  get createdAt() {
    return this.props.createdAt
  }
  get updatedAt() {
    return this.props.updatedAt
  }
  get origin() {
    return this.props.origin
  }

  static create(props: LeadDetailsProps) {
    return new LeadDetails(props)
  }
}